import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'

export default {
  namespaced: true,
  state: {
    isBusyLoading: true,
    customerInfo: null,
    branchOptions: [],
  },
  getters: {},
  mutations: {
    UPDATE_BUSY_LOADING_STATE(state, val) {
      state.isBusyLoading = val
    },
    UPDATE_CUSTOMER_INFO_STATE(state, val) {
      state.customerInfo = val
    },
    UPDATE_BRANCH_OPTIONS_STATE(state, val) {
      state.branchOptions = val
    },
  },
  actions: {
    // (查詢)會員列表
    getCustomerList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin/whmcs/clients', { headers: { 'Access-Token': useJwt.getToken() }, params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // (更新)會員驗證狀態
    setCustomerUpdate(ctx, resolveData) {
      return new Promise((resolve, reject) => {
        axios(`/admin/whmcs/kyc/${resolveData.user_id}`, {
          method: 'POST',
          headers: {
            'Access-Token': useJwt.getToken(),
          },
          data: {
            ...resolveData.data,
          },
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    // (刪除)會員驗證圖片
    setCustomerImageDelete(ctx, resolveData) {
      return new Promise((resolve, reject) => {
        axios(`/admin/whmcs/kyc/${resolveData.user_id}`, {
          method: 'DELETE',
          headers: {
            'Access-Token': useJwt.getToken(),
          },
          data: {
            ...resolveData.data,
          },
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
